import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import LazyPageWrapper from './components/LazyPageWrapper';
import ErrorBoundary from './components/ErrorBoundary';
import EnhancedNavigation from './components/EnhancedNavigation';
import PerformanceMonitor from './components/PerformanceMonitor';
import { 
  LazyHome, 
  LazyAbout, 
  LazyEvents, 
  LazyCalendar, 
  LazyGallery, 
  LazyMembership, 
  LazyJoinNow, 
  LazyTerms, 
  LazyPrivacy, 
  LazyAdmin 
} from './pages/LazyPages';
import PasswordResetPage from './components/admin/PasswordResetPage';

function App() {
  // Scroll to top on page refresh/load
  useEffect(() => {
    // Immediate scroll to top for page refreshes
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, []);
  return (
    <ErrorBoundary>
      <Router>
        <EnhancedNavigation>
            <div className="App min-h-screen">
            <PerformanceMonitor />
            <ScrollToTop />
            <Routes>
              <Route path="/" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Home..." fallbackTime={300}>
                    <LazyHome />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/about" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading About..." fallbackTime={1000}>
                    <LazyAbout />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/events" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Events..." fallbackTime={1300}>
                    <LazyEvents />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/calendar" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Calendar..." fallbackTime={1500}>
                    <LazyCalendar />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/gallery" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Gallery..." fallbackTime={1400}>
                    <LazyGallery />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/join" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Join Now..." fallbackTime={1000}>
                    <LazyJoinNow />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/membership" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Membership..." fallbackTime={1000}>
                    <LazyMembership />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/terms" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Terms..." fallbackTime={800}>
                    <LazyTerms />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/privacy" element={
                <>
                  <Header />
                  <LazyPageWrapper fallbackMessage="Loading Privacy..." fallbackTime={800}>
                    <LazyPrivacy />
                  </LazyPageWrapper>
                  <Footer />
                  <ScrollToTopButton />
                </>
              } />
              <Route path="/reset-password" element={<PasswordResetPage />} />
              <Route path="/admin/*" element={
                <ErrorBoundary fallback={
                  <div className="min-h-screen flex items-center justify-center bg-gray-50">
                    <div className="text-center">
                      <h2 className="text-xl font-semibold text-gray-900 mb-2">Admin Panel Error</h2>
                      <p className="text-gray-600 mb-4">There was an error loading the admin panel.</p>
                      <button
                        onClick={() => window.location.reload()}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md"
                      >
                        Reload Page
                      </button>
                    </div>
                  </div>
                }>
                  <LazyPageWrapper fallbackMessage="Loading Admin Panel..." fallbackTime={2000}>
                    <LazyAdmin />
                  </LazyPageWrapper>
                </ErrorBoundary>
              } />
            </Routes>
          </div>
        </EnhancedNavigation>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
